import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import { FaCheck } from "react-icons/fa";
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from "../AppApis";
import CancelSubscriptionPopup from "./CancelSubscriptionPopup";
import UpgradePopup from "./UpgradePopup";

const array = [
    {
        planName: "Essential Listing",
        price: "$0/month",
        package_type: "basic",
        description: "Best for entry-level sellers exploring MLS exposure, providing a simple way to list on major platforms.",
        offers: [
            { title: "MLS Listing", description: "Live within 24 hours on Zillow, Realtor, Trulia & more" },
            { title: "Photos", description: "Standard MLS limit" },
            { title: "Marketing Support", description: "Self-service (FAQs, Guides, Videos)" },
            { title: "Listing Period", description: "3 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
    },
    {
        planName: "MarketBlast Pro",
        price: "$59/month",
        package_type: "deluxe",
        description: "Best for intermediate sellers wanting better visibility & professional reviews to attract more buyers.",
        offers: [
            { title: "MLS Listing", description: "All MarketBlast features plus priority support" },
            { title: "Photos", description: "Unlimited (MLS Max)" },
            { title: "Marketing Support", description: "Weekly Marketing Review & Refresh" },
            { title: "Listing Period", description: "12 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
    },
    {
        planName: "MarketBlast",
        price: "$29/month",
        package_type: "premium",
        description: "Intermediate sellers who want improved visibility and professional reviews.",
        offers: [
            { title: "MLS Listing", description: "Everything in Essential, plus enhanced marketing" },
            { title: "Photos", description: "MLS Max" },
            { title: "Marketing Support", description: "Monthly Marketing Review & Refresh" },
            { title: "Listing Period", description: "6 Months" },
            { title: "Compliance Fee", description: "0.50% at closing" },
        ],
    },
];
export default function ManageSubscription() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState(0);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [isCancelPopupVisible, setIsCancelPopupVisible] = useState(false);
    const [isUpgradePopupVisible, setIsUpgradePopupVisible] = useState(false);

    const getProperty = async () => {
        try {
            const response = await getApi(`/properties/get_public_property/${id}`);
            const propertyData = response.response.data;
            setPropertyDetails(propertyData);
            let plan = propertyData.package_type === "basic" ? 0 : propertyData.package_type === "deluxe" ? 1 : 2;
            setSelectedPlan(plan);
        } catch (error) {
            console.log("🚀 ~ getProperty ~ error:", error);
        }
    };
    useEffect(() => {
        getProperty();
    }, []);
    const isCurrentPlan = (index) => {
        if (propertyDetails?.package_type && array[index].package_type === propertyDetails?.package_type) {
            return true;
        } else {
            return false;
        }
    };

    const handleClick = () => {
        if (isCurrentPlan(selectedPlan) || selectedPlan === 0) {
            setIsCancelPopupVisible(true);
        } else {
            setIsUpgradePopupVisible(true);
        }
    };
    return (
        <div className="tw-bg-[#eaeef4]">
            <Header title={"Subscriptions"} />
            <div className="tw-p-5 tw-pt-[100px] tw-px-10 md:tw-px-[100px] 2xl:[80%] 3xl:tw-w-[70%]">
                <h2 className="tw-text-[30px] xl:tw-text-[35px] 3xl:tw-text-[40px] tw-font-[600] tw-text-black">Subscriptions</h2>
                <div className="tw-bg-white tw-rounded-[15px] tw-p-5 tw-w-full  tw-mt-10">
                    <div className="tw-flex tw-justify-between tw-items-center">
                        <p className="tw-text-black tw-font-[800] tw-text-[20px]">
                            {" "}
                            {isCurrentPlan(selectedPlan) ? "Your Current Plan Overview" : "Selected Plan Overview"}
                        </p>
                        <p className="tw-text-medium_text tw-text-[12px]">Next Billing Date: {propertyDetails?.next_billing_date || "N/A"}</p>
                    </div>
                    <div className="tw-border tw-border-border_color tw-rounded-[8px] tw-p-5 tw-mt-5">
                        <p className="tw-text-black tw-font-[700] tw-text-[20px] xl:tw-text-[24px]">{array[selectedPlan].planName}</p>
                        <p className="tw-text-primary tw-font-[700] tw-text-[24px] xl:tw-text-[28px]">{array[selectedPlan].price}</p>
                        {array[selectedPlan].offers.map((item, index) => {
                            return (
                                <div key={index} className="tw-flex tw-mt-5">
                                    <FaCheck size={13} color="#1ABC9C" className="tw-mb-0 tw-mt-2 " />
                                    <p className="tw-text-black tw-text-[16px] tw-font-[600] tw-ml-2">{item.title}: </p>
                                    <p className="tw-text-black tw-text-[16px] tw-font-[400]">{item.description}</p>
                                </div>
                            );
                        })}
                    </div>
                    <button
                        onClick={handleClick}
                        className={`tw-text-center tw-mt-3 ${!isCurrentPlan(selectedPlan) ? "tw-text-[#009721]" : "tw-text-alert"} tw-text-[21px] tw-w-full`}
                    >
                        {isCurrentPlan(selectedPlan)
                            ? selectedPlan === 0
                                ? ""
                                : "Cancel Subscription"
                            : selectedPlan === 0
                              ? "Update to Essential"
                              : "Upgrade Plan"}
                    </button>
                </div>
                {propertyDetails?.downgrade_to && (
                    <p className="tw-text-alert tw-mt-5">
                        Note: You will be downgraded to {propertyDetails?.downgrade_to} plan on {propertyDetails?.next_billing_date}
                    </p>
                )}
                <p></p>
                <div className="tw-w-full tw-flex tw-flex-col xl:tw-flex-row tw-mt-5 tw-justify-between tw-gap-5">
                    {array.map((item, index) => {
                        return (
                            <div
                                onClick={() => setSelectedPlan(index)}
                                key={index}
                                className="tw-w-full xl:tw-w-[32%]  tw-bg-white tw-rounded-[15px] tw-p-5 tw-cursor-pointer"
                            >
                                <div className="tw-flex tw-items-center tw-gap-5 tw-border-b tw-border-border_color tw-pb-2">
                                    {selectedPlan === index ? (
                                        <IoIosRadioButtonOn size={30} color="#1ABC9C" />
                                    ) : (
                                        <IoIosRadioButtonOff size={30} color="#7F8C8D" />
                                    )}
                                    <p className="tw-text-black tw-text-[20px] xl:tw-text-[24px] tw-font-[700]">{item.planName}</p>
                                </div>
                                <p className="tw-text-primary tw-text-[18px] xl:tw-text-[25px] tw-font-[700] tw-mt-2">{item.price}</p>
                                <p className="tw-text-black tw-text-[12px] tw-mt-3">{item.description} </p>
                            </div>
                        );
                    })}
                </div>
            </div>
            {isCancelPopupVisible && (
                <CancelSubscriptionPopup onClose={() => setIsCancelPopupVisible(false)} propertyDetails={propertyDetails} navigate={navigate} />
            )}
            {isUpgradePopupVisible && (
                <UpgradePopup
                    onClose={() => setIsUpgradePopupVisible(false)}
                    propertyDetails={propertyDetails}
                    navigate={navigate}
                    package_type={array[selectedPlan].package_type}
                />
            )}
        </div>
    );
}
